<template>
  <div class="nav_container">
    <div class="header_top">
      <div class="inner">
        您好，欢迎进入江西师范大学资产经营有限责任公司官网！
      </div>
    </div>
    <div class="inner">
      <div class="header_logo">
        <img class="logo" src="@/assets/images/home/logo.png" />
        <div class="search">
          <el-input
            v-model="key"
            placeholder="站内搜索"
            size="mini"
            class="search_ipt"
            clearable
          >
            <el-button size="mini" type="primary" slot="append" @click="search">
              <i class="iconfont icon-sousuo"></i>
            </el-button>
          </el-input>
        </div>
      </div>
    </div>
    <div class="nav">
      <div class="inner">
        <ul>
          <li :class="{ active: activePath === '/home' }" @click="goHome">
            首页
          </li>
          <li
            v-for="(firItem, firIdx) in navList"
            :key="firIdx"
            @click.stop="goToPage(firItem.path, firItem.val)"
            :class="{
              active:
                activePath === firItem.path ||
                activePath === firItem.detailPath,
            }"
          >
            {{ firItem.val }}
            <div
              class="sub_menu"
              v-if="firItem.children && firItem.children.length > 0"
            >
              <div
                class="sub_menu_item"
                v-for="(secItem, secIdx) in firItem.children"
                :key="secIdx"
                @click.stop="goToPage(firItem.path, secItem.val)"
              >
                {{ secItem.val }}
                <div
                  class="sub__menu"
                  v-if="secItem.children && secItem.children.length > 0"
                >
                  <div
                    class="sub_menu__item"
                    v-for="(thrItem, thrIdx) in secItem.children"
                    :key="thrIdx"
                    @click.stop="
                      goToPage(firItem.path, thrItem.val, thrItem.parentVal)
                    "
                  >
                    {{ thrItem.val }}
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      key: "",
      navList: [
        {
          val: "公司概况",
          path: "/introduce",
          detailPath: "/introduceDetail",
          children: [
            {
              val: "公司简介",
            },
            {
              val: "公司领导",
            },
            {
              val: "组织机构",
            },
            {
              val: "企业荣誉",
            },
          ],
        },
        {
          val: "公司资讯",
          path: "/news",
          detailPath: "/newsDetail",
          children: [
            {
              val: "新闻快讯",
            },
            {
              val: "公司要闻",
            },
            {
              val: "工作动态",
            },
            {
              val: "通知公告",
            },
            {
              val: "基层动态",
            },
            {
              val: "公告信息",
            },
            {
              val: "招租公告",
            },
          ],
        },
        {
          val: "产业布局",
          path: "/layout",
          detailPath: "/layoutDetail",
          children: [
            {
              val: "后勤服务",
              children: [
                {
                  parentVal: "后勤服务",
                  val: "后勤公司",
                },
                {
                  parentVal: "后勤服务",
                  val: "餐饮公司",
                },
                {
                  parentVal: "后勤服务",
                  val: "物业公司",
                },
              ],
            },
            {
              val: "产学研合作",
              children: [
                {
                  parentVal: "产学研合作",
                  val: "科技园",
                },
                {
                  parentVal: "产学研合作",
                  val: "生产力促进中心",
                },
                {
                  parentVal: "产学研合作",
                  val: "城市规划研究院",
                },
              ],
            },
            {
              val: "商务旅游",
              children: [
                {
                  parentVal: "商务旅游",
                  val: "金日旅行社",
                },
                {
                  parentVal: "商务旅游",
                  val: "白鹿会馆",
                },
                {
                  parentVal: "商务旅游",
                  val: "学术交流中心",
                },
              ],
            },
            {
              val: "文化传播",
              children: [
                {
                  parentVal: "文化传播",
                  val: "新华师大书店",
                },
                {
                  parentVal: "文化传播",
                  val: "印刷厂",
                },
              ],
            },
          ],
        },
        {
          val: "党群工作",
          path: "/work",
          detailPath: "/workDetail",
          children: [
            {
              val: "组织简介",
            },
            {
              val: "党风廉政",
            },
            {
              val: "支部建设",
            },
            {
              val: "工会活动",
            },
            {
              val: "职工风采",
            },
          ],
        },
        {
          val: "专题活动",
          path: "/activity",
          detailPath: "/activityDetail",
          children: [
            {
              val: "学习贯彻习近平新时代中国特色社会主义思想",
            },
            {
              val: "不忘初心牢记使命",
            },
            {
              val: "党史学习教育",
            },
          ],
        },
        {
          val: "办事指南",
          path: "/guide",
          detailPath: "/guideDetail",
          children: [
            {
              val: "制度法规",
            },
            {
              val: "资料下载",
            },
            {
              val: "人才招聘",
            },
            // {
            //     val: '在线留言',
            // },
            {
              val: "联系我们",
            },
          ],
        },
      ],
      activePath: "",
    };
  },
  watch: {
    $route(val) {
      this.activePath = val.path;
      this.key = val.query.key;
    },
  },
  created() {
    this.activePath = this.$route.path;
    this.key = this.$route.query.key;
  },
  methods: {
    search() {
      let key = this.key || "";
      let toKey = this.$route.query.key;
      if (this.activePath === "/search" && key === toKey) {
        return;
      }
      this.$router.push({
        path: "/search",
        query: {
          key,
        },
      });
    },
    goToPage(path, current, parent) {
      let toCurrent = this.$route.query.current;
      if (this.activePath === path && toCurrent === current) {
        return;
      }

      this.$router.push({
        path,
        query: {
          current,
          parent,
        },
      });
    },
    goHome() {
      if (this.activePath === "/home") {
        return;
      }
      this.$router.push("/home");
    },
  },
};
</script>

<style lang="scss" scoped>
.nav_container {
  width: 100%;
  .inner {
    width: 1110px;
    margin: 0 auto;
  }
  .header_top {
    height: 34px;
    line-height: 34px;
    background: #fef4f4;
    color: #666;
    font-size: 12px;
  }
  .header_logo {
    height: 130px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .search {
      .search_ipt {
        ::v-deep .el-input-group__append {
          background-color: #a13838;
          color: #fff;
          border: 1px #a13838 solid;
        }
      }
    }
  }
  .nav {
    background-color: #a13838;
    ul {
      display: flex;
      li {
        flex: 1;
        height: 46px;
        line-height: 46px;
        text-align: center;
        color: #fff;
        cursor: pointer;
        position: relative;
        font-size: 16px;
        &::before {
          content: "";
          width: 1px;
          height: 14px;
          position: absolute;
          top: 50%;
          left: 0;
          background-color: #fff;
          transform: translateY(-50%);
        }
        &:first-child::before {
          display: none;
        }
        &:hover {
          background: rgba(0, 0, 0, 0.3);
          .sub_menu {
            display: block;
          }
          &::before,
          & + li::before {
            display: none;
          }
        }
        &.active {
          background: rgba(0, 0, 0, 0.3);
          &::before,
          & + li::before {
            display: none;
          }
        }
        .sub_menu {
          position: absolute;
          bottom: 0;
          left: 0;
          transform: translateY(100%);
          width: 100%;
          display: none;
          transition: height 0.3s ease-in-out;
          z-index: 9;
          font-size: 14px;
          .sub_menu_item {
            position: relative;
            background: rgba(0, 0, 0, 0.3);
            padding: 15px 6px;
            line-height: 1.5;
            &:hover {
              background: rgba(161, 56, 56, 0.5);
              .sub__menu {
                display: block;
              }
            }
            .sub__menu {
              position: absolute;
              right: 0;
              top: 0;
              transform: translateX(100%);
              width: 100%;
              z-index: 99;
              display: none;
              .sub_menu__item {
                background: rgba(0, 0, 0, 0.3);
                &:hover {
                  background: rgba(161, 56, 56, 0.5);
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
